import React from "react";
import styles from "./mentalmath.module.css";
import API_CONFIG from '../../config/api';

const AdvantageItem = ({ advantage }) => {
  return (
    <div className={styles.advantageItem}>
      <img
        // src={advantage.imgSrc}
        src={`${API_CONFIG.IMAGES_URL}/${advantage.imgSrc}`}
        alt={advantage.alt}
        className={styles.advantageImage}
      />
      <h3 className={styles.advantageTitle}>{advantage.title}</h3>
      <p className={styles.advantageText}>{advantage.text}</p>
    </div>
  );
};

export default AdvantageItem;
